import { render, staticRenderFns } from "./nice-button-2.vue?vue&type=template&id=7d1cdf96&scoped=true"
import script from "./nice-button-2.vue?vue&type=script&lang=js"
export * from "./nice-button-2.vue?vue&type=script&lang=js"
import style0 from "./nice-button-2.vue?vue&type=style&index=0&id=7d1cdf96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1cdf96",
  null
  
)

export default component.exports